import Achievements from "../components/achievements/Achievements";
import DataCollection from "../components/servicesPage/DataCollection";
import ServicesHero from "../components/servicesPage/ServicesHero";



const Services = () => {
   return(
      <div>
         <ServicesHero />
         <DataCollection />
         <Achievements />

      </div>
   )
}

export default Services;